import { useQuery } from "react-query";
import LoadingApiQuery from "../../../../../../components/LoadingApiQuery";
import axiosClient from "../../../../../../lib/axios";
import { Box, Typography } from "@mui/material";
import { useEffect } from "react";

export default function LoadingFechamento({ id, label, onFechado }: LoadingFechamentoProps) {

    const { data, isLoading, refetch } = useQuery({
        queryKey: 'status-fechamento',
        queryFn: () => axiosClient.get(`/financeiro/conta-corrente-consumo/status-fechamento/${id}`),
        keepPreviousData: true,
        refetchOnWindowFocus: false,
        refetchInterval: 1000,
    });

    useEffect(() => {
        if (data?.data.status === "Fechado") {
            onFechado?.()
        }
    }, [data?.data.status])


    return (
        <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" py={3}>
            <LoadingApiQuery />
            <Typography>{label}</Typography>
            <Typography>{data?.data.status_detalhe}</Typography>
        </Box>
    )
}

interface LoadingFechamentoProps {
    id: number
    label: string
    onFechado?: () => void
}